import { defineComponent as Z, ref as m, computed as D, watch as T, openBlock as F, createElementBlock as S, createBlock as $, createCommentVNode as q, createVNode as K, normalizeClass as z, withDirectives as ce, createElementVNode as E, vShow as ve, Fragment as ue, renderList as de, toDisplayString as re, inject as ke, onMounted as fe, unref as w, withCtx as Y, provide as be } from "vue";
import { h as ge, _ as Ie } from "./index.cf4295be.js";
import { RadioInputList as De } from "../radioInputList.es.js";
import { SearchBar as Ce } from "../searchBar.es.js";
import { g as ye, _ as Re } from "./index.ed7e1cd9.js";
import { _ as xe } from "./index.053d2b9b.js";
import { Accordion as Le, AccordionItem as Ae } from "../accordion.es.js";
import { Button as pe } from "../button.es.js";
import { _ as _e, f as Be, g as $e } from "./index.bb65e9d2.js";
import { e as V, p as me } from "./calendarHelper.9c81d081.js";
import '../assets/index7.css';const Se = {
  mounted(c, y) {
    const s = new ResizeObserver((_) => {
      _.forEach(() => {
        const h = c.offsetHeight, L = c.scrollHeight > h;
        y.value && typeof y.value == "function" && y.value(L);
      });
    });
    c.__resizeObserver__ = s, s.observe(c);
  },
  unmounted(c) {
    c.__resizeObserver__ && (c.__resizeObserver__.disconnect(), delete c.__resizeObserver__);
  }
};
var R = /* @__PURE__ */ ((c) => (c.RadioButtonList = "radioButtonList", c.Alphabet = "alphabet", c.DateRangePicker = "dateRangePicker", c))(R || {});
function he() {
  return 8;
}
const we = {
  class: "FilterRadioInputList",
  ref: "filterRadioInputList"
}, Ve = { class: "FilterRadioInputList__emptyCase" }, Pe = /* @__PURE__ */ Z({
  __name: "FilterRadioInputList",
  props: {
    filter: {},
    selectedFilters: {},
    resetSearchBar: { type: Boolean, default: !1 },
    resetRadioInputExpand: { type: Boolean, default: !1 }
  },
  emits: ["radio-input-expand", "change"],
  setup(c, { emit: y }) {
    const s = c, _ = m(""), h = m(he()), I = m(!1), L = D(() => s.filter.items ? s.filter.items.length > h.value : !1), n = D(() => _.value.trim().length > 0), C = D(() => {
      const u = s.filter.items ? [...s.filter.items] : [];
      return u.find(
        (d) => d.value === s.filter.defaultItem.value
      ) || u.unshift(s.filter.defaultItem), _.value.trim() ? u.filter(
        (d) => d.label.toLowerCase().includes(_.value.toLowerCase())
      ).map((d) => ({
        value: d.value,
        label: M(d.label)
      })) : u;
    }), k = (u) => {
      const v = s.selectedFilters.find(
        (d) => d.key === u.key
      );
      return v ? v.selectedItem.label : u.defaultItem.label;
    }, r = (u, v) => {
      const d = s.filter.items ? s.filter.items.find((B) => B.value === v.value) : void 0;
      if (d) {
        const B = d.label, O = {
          value: v.value,
          label: B
        };
        y("change", u, O);
      } else
        y("change", u, v);
    }, x = () => {
      _.value = "";
    }, P = () => {
      y("radio-input-expand", s.filter);
    }, M = (u) => ge(u, _.value, 0);
    return T(
      () => n.value,
      (u) => {
        u && P();
      }
    ), T(
      () => s.resetSearchBar,
      () => {
        _.value = "";
      }
    ), T(
      () => s.resetRadioInputExpand,
      () => {
        const u = s.selectedFilters.find(
          (v) => v.key === s.filter.key
        );
        u && s.filter.items && s.filter.items.findIndex(
          (d) => d.value === u.selectedItem.value
        ) >= h.value || (I.value = !I.value, y("radio-input-expand"));
      }
    ), (u, v) => (F(), S("div", we, [
      L.value ? (F(), $(Ce, {
        modelValue: _.value,
        "onUpdate:modelValue": v[0] || (v[0] = (d) => _.value = d),
        onClear: x,
        key: s.filter.key
      }, null, 8, ["modelValue"])) : q("", !0),
      K(De, {
        name: u.filter.key,
        options: C.value,
        maxOptions: h.value,
        dataText: "label",
        value: k(u.filter),
        "reset-expand": I.value,
        onChange: v[1] || (v[1] = (d) => r(d.name, d.value)),
        onExpand: P,
        class: z({ "RadioInputList__wrapper--searching": n.value })
      }, null, 8, ["name", "options", "maxOptions", "value", "reset-expand", "class"]),
      ce(E("div", Ve, " No matches to your query could be found. Try another search term. ", 512), [
        [ve, C.value.length === 0]
      ])
    ], 512));
  }
});
const Ee = { class: "Alphabet" }, Te = ["onClick"], Me = /* @__PURE__ */ Z({
  __name: "AlphabetFilter",
  props: {
    filter: {},
    selectedFilters: {}
  },
  emits: ["change"],
  setup(c, { emit: y }) {
    const s = c, _ = m(ye()), h = D(() => {
      const n = s.selectedFilters.find(
        (C) => {
          var k;
          return C.key === ((k = s.filter) == null ? void 0 : k.key);
        }
      );
      return n ? n.selectedItem.label : "All";
    }), I = (n) => {
      var r;
      const C = _.value[n], k = {
        value: C.toLowerCase(),
        label: C
      };
      y("change", (r = s.filter) == null ? void 0 : r.key, k);
    }, L = (n) => n.toLowerCase() === h.value.toLowerCase();
    return (n, C) => (F(), S("div", Ee, [
      (F(!0), S(ue, null, de(_.value, (k, r) => {
        var x;
        return F(), S("button", {
          key: r,
          class: z(["Alphabet__letter", {
            "Alphabet__letter--active": L(k),
            "is-disabled": ((x = n.filter) == null ? void 0 : x.disabledLetters) && n.filter.disabledLetters.includes(k)
          }]),
          onClick: (P) => I(r)
        }, re(k), 11, Te);
      }), 128))
    ]));
  }
}), Oe = { class: "ButtonFiltersContainerModal__body" }, He = /* @__PURE__ */ Z({
  __name: "ButtonFiltersContainerModal",
  props: {
    filters: {},
    appliedFiltersProp: { default: () => [] },
    forceClearAllFilters: { type: Boolean, default: !1 }
  },
  emits: ["apply"],
  setup(c, { emit: y }) {
    const s = c, _ = Se, h = ke("isVisibleFilterModal"), I = m(-1), L = m(!1), n = m(!1), C = m(!1), k = m(""), r = m([...s.appliedFiltersProp]), x = m([...s.appliedFiltersProp]), P = m(R.RadioButtonList), M = m(R.Alphabet), u = m(R.DateRangePicker), v = m(!1), d = m(null), B = m(null), O = m(null), ee = D(() => s.filters.find((l) => l.type === R.Alphabet));
    D(() => s.filters.find(
      (l) => l.type === R.DateRangePicker
    ));
    const te = D(() => r.value.length > 0), W = D(() => s.filters.length === 1), le = D(() => W.value ? "Clear filter" : "Clear all"), ae = D(() => W.value ? "Filter" : "Filters"), se = (l) => {
      const o = l.items && l.items.length === 0 || !l.items, i = l.type === M.value, b = l.type === u.value;
      return o && !i && !b;
    }, ne = (l) => {
      let o = "";
      const i = r.value.find(
        (b) => b.key === l.key
      );
      if (i) {
        const g = i.selectedItem.value.split("-")[0].split("/"), H = `${g[2]}-${g[1]}-${g[0]}`;
        o = V(new Date(H));
      }
      return o;
    }, N = (l) => {
      let o = "";
      const i = r.value.find(
        (b) => b.key === l.key
      );
      if (i) {
        const g = i.selectedItem.value.split("-")[1].split("/"), H = `${g[2]}-${g[1]}-${g[0]}`;
        o = V(new Date(H));
      }
      return o;
    }, G = (l, o) => {
      let i = null;
      const b = V(o.from) + "-" + V(o.to);
      i = {
        label: o.title,
        value: b
      };
      const g = {
        key: l.key,
        selectedItem: i
      }, H = r.value.findIndex(
        (Fe) => Fe.key === l.key
      );
      if (H !== -1)
        r.value[H] = g;
      else {
        if (b === l.defaultItem.value)
          return;
        r.value.push(g);
      }
    }, t = (l) => {
      C.value = l;
    }, a = (l, o) => {
      const i = {
        key: l || "",
        selectedItem: o
      };
      r.value = r.value.filter(
        (g) => g.key !== l
      );
      const b = s.filters.find((g) => g.key === l);
      b && b.defaultItem.value === o.value || r.value.push(i);
    }, e = () => {
      h.value = !1, J(), Q(), j();
    }, p = () => {
      r.value = x.value, e();
    }, f = () => {
      const l = O.value;
      l && typeof l.apply == "function" && l.apply(), ie(), y("apply", x.value), e();
    }, A = (l = !1) => {
      r.value = [], v.value = !v, l && f();
    }, oe = (l) => {
      l ? k.value = l.key : k.value = "";
    }, ie = () => {
      x.value = [], r.value.forEach((l) => {
        const o = s.filters.find((i) => i.key === l.key);
        o && o.defaultItem.value !== l.selectedItem.value && x.value.push(l);
      });
    }, J = () => {
      L.value = !L.value;
    }, Q = () => {
      n.value = !n.value;
    }, U = () => {
      s.filters.length === 1 ? I.value = 0 : I.value = -1;
    }, j = () => {
      const l = B.value;
      l && typeof l.closeAllAccordionItems == "function" && (I.value = -1, l.closeAllAccordionItems());
    }, X = () => {
      if (typeof window > "u")
        return;
      const l = d.value ? d.value.$el : null;
      if (l) {
        let o = document.querySelector("#root");
        o || (o = document.querySelector("#storybook-root")), o || (o = document.querySelector("#__nuxt")), o || (o = document.querySelector(" body > div:first-of-type")), o && o.appendChild(l);
      }
    };
    return fe(() => {
      X();
    }), T(
      () => h.value,
      () => {
        U();
      }
    ), T(
      () => s.forceClearAllFilters,
      (l) => {
        l && A(!0);
      }
    ), T(
      () => s.appliedFiltersProp,
      (l) => {
        x.value = l, r.value = l;
      }
    ), (l, o) => (F(), $(xe, {
      ref_key: "modalComponentRef",
      ref: d,
      show: w(h),
      onClose: p,
      title: ae.value,
      class: z(["ButtonFiltersContainerModal", {
        "ButtonFiltersContainerModal--hasScroll": C.value
      }])
    }, {
      body: Y(() => [
        ce((F(), S("div", Oe, [
          K(w(Le), {
            "selected-index": I.value,
            ref_key: "accordionComponentRef",
            ref: B
          }, {
            default: Y(() => [
              (F(!0), S(ue, null, de(l.filters, (i) => (F(), $(w(Ae), {
                key: i.key,
                title: i.title,
                "is-disabled": se(i),
                class: z({
                  "Accordion__item--radioInputExpanded": k.value === i.key
                })
              }, {
                content: Y(() => [
                  i.type === P.value ? (F(), $(Pe, {
                    key: 0,
                    filter: i,
                    "selected-filters": r.value,
                    "reset-search-bar": L.value,
                    "reset-radio-input-expand": n.value,
                    onChange: a,
                    onRadioInputExpand: oe
                  }, null, 8, ["filter", "selected-filters", "reset-search-bar", "reset-radio-input-expand"])) : q("", !0),
                  i.type === M.value ? (F(), $(Me, {
                    key: 1,
                    filter: ee.value,
                    "selected-filters": r.value,
                    onChange: a
                  }, null, 8, ["filter", "selected-filters"])) : q("", !0),
                  w(h) && i.type === u.value ? (F(), $(_e, {
                    key: 2,
                    ref_for: !0,
                    ref_key: "dateRangePickerRef",
                    ref: O,
                    title: i.title,
                    from: ne(i),
                    to: N(i),
                    minDate: i.minDate,
                    maxDate: i.maxDate,
                    "in-button-filters-modal": !0,
                    selectedValue: i.defaultItem.value,
                    filter: i,
                    forceReset: v.value,
                    onChange: o[0] || (o[0] = (b, g) => a(b, g)),
                    onApply: (b) => G(i, b)
                  }, null, 8, ["title", "from", "to", "minDate", "maxDate", "selectedValue", "filter", "forceReset", "onApply"])) : q("", !0)
                ]),
                _: 2
              }, 1032, ["title", "is-disabled", "class"]))), 128))
            ]),
            _: 1
          }, 8, ["selected-index"])
        ])), [
          [w(_), t]
        ])
      ]),
      footer: Y(() => [
        K(pe, {
          type: "Outline",
          size: "Medium",
          text: le.value,
          class: z({ hidden: !te.value }),
          onClick: o[1] || (o[1] = () => A())
        }, null, 8, ["text", "class"]),
        K(pe, {
          type: "Flat",
          size: "Medium",
          text: "See results",
          onClick: f
        })
      ]),
      _: 1
    }, 8, ["show", "title", "class"]));
  }
});
const qe = {
  id: "ButtonFiltersContainer",
  class: "ButtonFiltersContainer",
  ref: "buttonFiltersContainer"
}, ze = { class: "ButtonFiltersContainer__filterList" }, Ne = { class: "ButtonFiltersContainer__filterItem" }, Ue = { class: "ButtonFiltersContainer__filterItem__button--more__shortTitle" }, tt = /* @__PURE__ */ Z({
  __name: "ButtonFiltersContainer",
  props: {
    filters: {
      type: Array,
      required: !0,
      validator: (c) => c.every(
        (y) => y.type === R.Alphabet || y.type === R.DateRangePicker || y.type === R.RadioButtonList && y.items
      )
    }
  },
  emits: ["apply"],
  setup(c, { emit: y }) {
    const s = c, _ = R, h = m(!1), I = m(!1), L = m(he()), n = m([]), C = m(ye());
    be("isVisibleFilterModal", h);
    const k = D(() => n.value.length > 0), r = D(() => s.filters.length === 1), x = D(
      () => r.value ? "Clear filter" : "Clear all"
    ), P = D(
      () => r.value ? "Filter" : "Filters"
    ), M = (t) => {
      const a = n.value.find((e) => e.key === t.key);
      return a ? a.selectedItem.label : "";
    }, u = (t) => t.items ? t.items.length > L.value : !1, v = () => {
      h.value = !h.value;
    }, d = () => {
      n.value = [], I.value = !I.value;
    }, B = (t) => {
      n.value = t, y("apply", t);
    }, O = (t, a) => {
      N(t, a);
    }, ee = (t, a) => {
      let e = null;
      a && (e = {
        label: a,
        value: a.toLowerCase()
      }), N(t, e);
    }, te = (t) => {
      const a = {}, e = t.disabledLetters || [];
      return C.value.forEach((p) => {
        e.includes(p) ? a[p] = !1 : a[p] = !0;
      }), a;
    }, W = (t) => {
      const a = n.value.find((e) => e.key === t.key);
      return a ? a.selectedItem.label : "All";
    }, le = (t) => {
      let a = "";
      const e = n.value.find(
        (p) => p.key === t.key
      );
      if (e) {
        const f = e.selectedItem.value.split("-")[0].split("/"), A = `${f[2]}-${f[1]}-${f[0]}`;
        a = V(new Date(A));
      }
      return a;
    }, ae = (t) => {
      let a = "";
      const e = n.value.find(
        (p) => p.key === t.key
      );
      if (e) {
        const f = e.selectedItem.value.split("-")[1].split("/"), A = `${f[2]}-${f[1]}-${f[0]}`;
        a = V(new Date(A));
      }
      return a;
    }, se = (t) => {
      const a = n.value.findIndex(
        (e) => e.key === t.key
      );
      a !== -1 && n.value.splice(a, 1);
    }, ne = (t, a) => {
      const e = V(a.from) + "-" + V(a.to);
      let p = null;
      p = {
        label: a.title,
        value: e
      }, N(t, p);
    }, N = (t, a) => {
      let e = n.value;
      if (n.value.find((f) => f.key === t.key) && (e = n.value.filter(
        (f) => f.key !== t.key
      )), a && a.value !== t.defaultItem.value) {
        const f = {
          key: t.key,
          selectedItem: a
        };
        e.push(f);
      }
      B(e);
    }, G = () => {
      s.filters.forEach((t) => {
        if (t.type === R.RadioButtonList && t.selectedValue !== void 0 && t.items) {
          n.value = n.value.filter(
            (e) => e.key !== t.key
          );
          const a = t.items.find(
            (e) => e.value === t.selectedValue
          );
          if (a) {
            const e = {
              key: t.key,
              selectedItem: {
                value: t.selectedValue,
                label: a.label
              }
            };
            n.value.push(e);
          }
        }
        if (t.type === R.Alphabet && t.selectedValue) {
          n.value = n.value.filter(
            (e) => e.key !== t.key
          );
          const a = {
            key: t.key,
            selectedItem: {
              value: t.selectedValue.toLowerCase(),
              label: t.selectedValue
            }
          };
          n.value.push(a);
        }
        if (t.type === R.DateRangePicker && t.dateFrom && t.dateTo) {
          const a = "[0-9]{2}/[0-9]{2}/[0-9]{4}", e = new RegExp(a, "g").test(
            t.dateFrom
          ), p = new RegExp(a, "g").test(
            t.dateTo
          );
          if (!e || !p)
            return;
          const f = t.dateFrom.split("/"), A = t.dateTo.split("/"), oe = `${f[2]}-${f[1]}-${f[0]}`, ie = `${A[2]}-${A[1]}-${A[0]}`, J = me(oe), Q = me(ie);
          if (J !== null && Q !== null) {
            const U = `${t.dateFrom}-${t.dateTo}`;
            if (U === t.defaultItem.value)
              return;
            let j = "";
            const X = Be(J, Q, t.presets), l = $e();
            X !== -1 ? j = l[X].title : j = U, n.value = n.value.filter(
              (i) => i.key !== t.key
            );
            const o = {
              key: t.key,
              selectedItem: {
                value: U,
                label: j
              }
            };
            n.value.push(o);
          }
        }
      });
    };
    return fe(() => {
      G();
    }), T(
      () => s.filters,
      () => {
        G();
      }
    ), (t, a) => (F(), S("div", qe, [
      E("ul", ze, [
        (F(!0), S(ue, null, de(c.filters, (e) => (F(), S("li", {
          key: e.key,
          class: "ButtonFiltersContainer__filterItem"
        }, [
          e.type === w(_).RadioButtonList ? (F(), $(Ie, {
            key: 0,
            "empty-option": e.defaultItem.label,
            title: e.title,
            items: e.items,
            "data-text": "label",
            "is-disabled": e.items && e.items.length === 0 || !e.items,
            "allow-auto-filter": !0,
            "allow-filter-options": u(e),
            "selected-value": M(e),
            onSelectedItem: (p) => O(e, p)
          }, null, 8, ["empty-option", "title", "items", "is-disabled", "allow-filter-options", "selected-value", "onSelectedItem"])) : e.type === w(_).Alphabet ? (F(), $(Re, {
            key: 1,
            id: "AlphabetDropDown",
            title: e.title,
            availableLetters: te(e),
            selectedLetter: W(e),
            "onUpdate:selectedLetter": (p) => ee(e, p)
          }, null, 8, ["title", "availableLetters", "selectedLetter", "onUpdate:selectedLetter"])) : q("", !0),
          !h.value && e.type === w(_).DateRangePicker ? (F(), $(_e, {
            key: 2,
            title: e.title,
            from: le(e),
            to: ae(e),
            minDate: e.minDate,
            maxDate: e.maxDate,
            selectedValue: e.defaultItem.value,
            presets: e.presets,
            filter: e,
            onApply: (p) => ne(e, p),
            onClear: (p) => se(e)
          }, null, 8, ["title", "from", "to", "minDate", "maxDate", "selectedValue", "presets", "filter", "onApply", "onClear"])) : q("", !0)
        ]))), 128)),
        E("li", null, [
          ce(E("button", {
            class: "ButtonFiltersContainer__clearAllButton",
            onClick: d
          }, re(x.value), 513), [
            [ve, k.value]
          ])
        ])
      ]),
      E("div", Ne, [
        E("button", {
          class: z(["ButtonFiltersContainer__filterItem__button ButtonFiltersContainer__filterItem__button--more", {
            "ButtonFiltersContainer__filterItem__button--moreActive": k.value
          }]),
          onClick: v
        }, [
          E("span", Ue, re(P.value), 1)
        ], 2)
      ]),
      K(He, {
        filters: c.filters,
        "applied-filters-prop": n.value,
        "is-visible-filter-modal": h.value,
        "force-clear-all-filters": I.value,
        onApply: B
      }, null, 8, ["filters", "applied-filters-prop", "is-visible-filter-modal", "force-clear-all-filters"])
    ], 512));
  }
});
export {
  Se as D,
  R as E,
  tt as _
};
